export default {
  window,
};
